import React from 'react'
import ReactMixin from 'react-mixin'
import ImmutableRenderMixin from 'react-immutable-render-mixin'
import { fromJS, Map, List } from 'immutable'
import { Nav, NavItem, Row, Col, ButtonToolbar, Button } from 'react-bootstrap'
import createLinkToImmutable from '_/utils/createLinkToImmutable'
import MetadataInput from '_/shared/components/metadataInput'
import Input from '_/shared/components/input'

/**
 * Record navigation
 */
@ReactMixin.decorate(ImmutableRenderMixin)
class SearchFields extends React.Component {
  static propTypes = {
    account: React.PropTypes.object.isRequired,
    colSize: React.PropTypes.number,
    geometry: React.PropTypes.object,
    metro: React.PropTypes.object.isRequired,
    metadata: React.PropTypes.object.isRequired,
    isMap: React.PropTypes.bool,
    onSavedSearch: React.PropTypes.func,
    onSubmit: React.PropTypes.func.isRequired,
    savedSearches: React.PropTypes.object,
  }

  static contextTypes = {
    store: React.PropTypes.object,
    router: React.PropTypes.func,
    notify: React.PropTypes.func
  }

  constructor (props, context) {
    super(props, context)

    const { store } = this.context
    const lastSearch = store.storage.lastSearch ? JSON.parse(store.storage.lastSearch) : {}
    const genUseTM = this.getGenUseTMList()

    this.state = {
      property: lastSearch.property ? fromJS(lastSearch.property) : Map({ genUseTM }),
      transaction: lastSearch.transaction ? fromJS(lastSearch.transaction) : Map({ type: 'Sale', isPrivate: false }),
      exhibit: lastSearch.exhibit ? fromJS(lastSearch.exhibit) : Map(),
      inspection: lastSearch.inspection ? fromJS(lastSearch.inspection) : Map(),
      showAdvProperty: false,
      showAdvTransaction: false,
      linkProperty: createLinkToImmutable(this, 'property'),
      linkTransaction: createLinkToImmutable(this, 'transaction'),
      linkExhibit: createLinkToImmutable(this, 'exhibit'),
      linkInspection: createLinkToImmutable(this, 'inspection'),
      searchBtnTxt: 'Search',
      disableSearchBtn: false,
      savedSearches: props.savedSearches
    }
  }

  getGenUseTMList () {
    const { account } = this.props

    let genUseTM = List()
    if (account.getIn(['group','isAg'])) {
      genUseTM = List(['Agriculture'])
    }
    if (account.getIn(['group','isSfr'])) {
      genUseTM = List(['Single Family Residential'])
    }
    return genUseTM
  }

  handleAdvanceProperty (evt) {
    this.setState({
      showAdvProperty: evt.target.checked
    })
  }

  handleAdvanceTransaction (evt) {
    this.setState({
      showAdvTransaction: evt.target.checked
    })
  }

  handleGenUseTM (item) {
    const { property } = this.state

    const genUseTM = property.get('genUseTM')
    const idx = genUseTM.indexOf(item)

    if (idx === -1) {
      this.setState({
        property: property.set('genUseTM', genUseTM.push(item))
      })
    }
    else {
      this.setState({
        property: property.set('genUseTM', genUseTM.delete(idx))
      })
    }
  }

  handleTransactionSwitch (state) {
    this.setState({
      transaction: Map({ type: state, isPrivate: false })
    })
  }

  renderField (model, field, isAdv) {
    const { metadata, colSize = 6 } = this.props
    const {
      linkProperty,
      linkTransaction,
      linkInspection,
      showAdvProperty,
      showAdvTransaction
    } = this.state

    if (isAdv && ((model === 'property' && !showAdvProperty) || (model !== 'property' && !showAdvTransaction))) {
      return null
    }

    const metaInfo = metadata.getIn([model, field])
    const hasRange = (
      metaInfo.get('inputType') === 'number' || metaInfo.get('inputType') === 'date'
    ) && !metaInfo.get('excludeRange')

    let placeholder = ''
    if (field === 'strName') placeholder = 'i.e.; 33rd -or- Grand'

    let link

    switch (model) {
      case 'property'    : link = linkProperty; break
      case 'inspection'  : link = linkInspection; break
      default            : link = linkTransaction
    }

    return (
      <MetadataInput
        hasLabel
        hasRange={hasRange}
        colSize={colSize}
        link={link}
        metadata={metaInfo}
        placeholder={placeholder}
        field={field}
        value={link(field)} />
    )
  }

  renderUseTMField (model) {
    const { metadata } = this.props
    const { linkTransaction, property } = this.state

    const metaInfo = metadata.get(model)
    let genUseTM = property.get('genUseTM')
    if (genUseTM.size === 0) {
      genUseTM = List(['Office', 'Industrial', 'Retail', 'Residential', 'Commercial', 'Vacant Land'])
    }

    return (
      <Input
        type="select"
        multi
        valueLink={linkTransaction('useTM')}
        options={
          metaInfo.getIn(['useTM', 'enumValues'])
            .filter(enu => {
              if (!genUseTM.size) return true
              const genUseL = enu.get('label').split(':')[0]
              return genUseTM.some(genUseR => genUseL === genUseR)
            })
            .map(enu => ({
              label: enu.get('label'),
              value: enu.get('value')
            }))
          .toJS()
        }
        label={metaInfo.getIn(['useTM', 'label'])} />
    )
  }

  renderPropertyTitle () {
    return (
      <Col sm={12}>
        <h4>
          Property
          <small style={{ paddingLeft: '10px' }}>
            Search on more fields <input type="checkbox" onClick={::this.handleAdvanceProperty} />
          </small>
        </h4>
      </Col>
    )
  }

  renderTransactionTitle (type) {
    return (
      <Col sm={12}>
        <h4>
          {type}
          <small style={{ paddingLeft: '10px' }}>
            Search on more fields <input type="checkbox" onClick={::this.handleAdvanceTransaction} />
          </small>
        </h4>
      </Col>
    )
  }

  renderGeometryInstructions () {
    const { isMap } = this.props

    if (!isMap) return null

    return (
      <div>
        <p><strong>Tip: Search an area by drawing a polygon on the map.</strong></p>
        <hr className="redi-component-hr" />
      </div>
    )
  }

  renderGenUseTMHolder (type, disabled) {
    const { isMap } = this.props

    if (isMap) {
      return (
        <Col xs={4}>
          {this.renderGenUseTMItem(type, disabled)}
        </Col>
      )
    }

    return (
      <span style={{ paddingLeft: '15px' }}>
        {this.renderGenUseTMItem(type, disabled)}
      </span>
    )
  }

  renderGenUseTMItem (type, disabled) {
    const { property } = this.state

    return (
      <label>
        <input
          disabled={disabled}
          type="checkbox"
          name="genUseTM"
          checked={property.get('genUseTM').includes(type)}
          onClick={this.handleGenUseTM.bind(this, type)} />
        <strong
          title={disabled && 'Unavailable in map search'}
          style={{ paddingLeft: '5px' }}
          className={disabled && 'text-muted'}>
          {type}
        </strong>
      </label>
    )
  }

  renderPropertyFields () {
    const { metro, colSize = 6, isMap, account } = this.props
    const { linkProperty, showAdvProperty } = this.state
    const isAgRes = account.get('isAgRes')

    return (
      <Row>
        {this.renderPropertyTitle()}

        {!isAgRes &&
          <Col xs={12}>
            <p>
              General property use:
              {isMap && <br />}
              {this.renderGenUseTMHolder('Office')}
              {this.renderGenUseTMHolder('Industrial')}
              {this.renderGenUseTMHolder('Retail')}
              {this.renderGenUseTMHolder('Residential')}
              {this.renderGenUseTMHolder('Commercial')}
              {this.renderGenUseTMHolder('Vacant Land', isMap)}
            </p>
          </Col>
        }

        <Col xs={colSize}>
          {isMap && <br/>}
          {!isMap &&
            <Row>
              <Col sm={8}>
                <Input
                  type="select"
                  multi
                  valueLink={linkProperty('county')}
                  options={
                    metro.get('countiesM').map(county => ({
                      label: county,
                      value: county
                    }))
                    .toJS()
                  }
                  label="County" />
              </Col>
              <Col sm={4}>
                <Input
                  type="select"
                  multi
                  valueLink={linkProperty('state')}
                  options={
                    metro.get('statesM').map(state => ({
                      label: state,
                      value: state
                    }))
                    .toJS()
                  }
                  label="State" />
              </Col>
            </Row>
          }

          {!isMap &&
            <Input
              type="select"
              multi
              valueLink={linkProperty('city')}
              options={
                metro.get('citiesM').sort().map(city => ({
                  label: city,
                  value: city
                }))
                .toJS()
              }
              label="City" />
          }

          {this.renderField('property', 'strNo', true)}
          {this.renderField('property', 'strName', true)}
          {showAdvProperty && <Input type="text-multi" valueLink={linkProperty('zip')} label="Zip code" />}
          {this.renderField('property', 'builtYr')}
          {this.renderField('property', 'bldgClsT', true)}
          {this.renderField('property', 'airT', true)}
          {this.renderField('property', 'railSrv', true)}
          {this.renderField('property', 'clrHtHighFt', true)}
          {this.renderField('property', 'clrHtLowFt', true)}
          {this.renderField('property', 'clrHtAvgFt', true)}
        </Col>

        <Col xs={colSize}>
          {this.renderField('property', 'pid')}
          {this.renderField('property', 'storiesCt')}
          {this.renderField('property', 'unitCt')}
          {this.renderField('property', 'gbaSf', true)}
          {this.renderField('property', 'landSf', true)}
          {this.renderField('property', 'acresCt', true)}
          {this.renderField('property', 'ownedT', true)}
          {this.renderField('property', 'occupPct', true)}
          {this.renderField('property', 'tenantCt', true)}
          {this.renderField('property', 'tenantT', true)}
          {this.renderField('property', 'vacancyPct', true)}
          {this.renderField('property', 'dockCt', true)}
          {this.renderField('property', 'drvDoorsCt', true)}
        </Col>

        <Col sm={12}>
          {this.renderField('property', 'bldgRemarks', true)}
        </Col>
      </Row>
    )
  }

  renderPropertySfrFields () {
    const { metro, colSize = 6, isMap } = this.props
    const { linkProperty } = this.state

    return (
      <Row>
        {this.renderPropertyTitle()}

        <Col xs={colSize}>
          {isMap && <br/>}
          {!isMap &&
            <Row>
              <Col sm={8}>
                <Input
                  type="select"
                  multi
                  valueLink={linkProperty('county')}
                  options={
                    metro.get('countiesM').map(county => ({
                      label: county,
                      value: county
                    }))
                    .toJS()
                  }
                  label="County" />
              </Col>
              <Col sm={4}>
                <Input
                  type="select"
                  multi
                  valueLink={linkProperty('state')}
                  options={
                    metro.get('statesM').map(state => ({
                      label: state,
                      value: state
                    }))
                    .toJS()
                  }
                  label="State" />
              </Col>
            </Row>
          }

          {!isMap &&
            <Input
              type="select"
              multi
              valueLink={linkProperty('city')}
              options={
                metro.get('citiesM').sort().map(city => ({
                  label: city,
                  value: city
                }))
                .toJS()
              }
              label="City" />
          }

          {this.renderField('property', 'strNo', true)}
          {this.renderField('property', 'strName')}
          {this.renderField('property', 'gbaSf', true)}
          {this.renderField('property', 'landSf', true)}
          {this.renderField('property', 'nhT', true)}
          {this.renderField('property', 'bsmtT', true)}
          {this.renderField('property', 'garagePkTM', true)}
          {this.renderField('property', 'floodZoneTM', true)}
        </Col>

        <Col xs={colSize}>
          {this.renderField('property', 'pid')}
          {this.renderField('property', 'acresCt')}
          {this.renderField('property', 'hasWtrFrntg')}
          {this.renderField('property', 'wtrFrntName', true)}
          {this.renderField('property', 'wtrFrntFt', true)}
          {this.renderField('property', 'roomCt', true)}
          {this.renderField('property', 'bedroomCt', true)}
          {this.renderField('property', 'bathroomCt', true)}
          {this.renderField('property', 'storiesCt', true)}
          {this.renderField('property', 'hasWater', true)}
          {this.renderField('property', 'waterOther', true)}
          {this.renderField('property', 'hasSewer', true)}
          {this.renderField('property', 'sewerOther', true)}
        </Col>

        <Col sm={12}>
          {this.renderField('property', 'bldgRemarks', true)}
          {this.renderField('property', 'siteRemarks', true)}
        </Col>
      </Row>
    )
  }

  renderPropertyAgFields () {
    const { metro, colSize = 6, isMap } = this.props
    const { linkProperty } = this.state

    return (
      <Row>
        {this.renderPropertyTitle()}

        <Col xs={colSize}>
          {isMap && <br/>}
          {!isMap &&
            <Row>
              <Col sm={8}>
                <Input
                  type="select"
                  multi
                  valueLink={linkProperty('county')}
                  options={
                    metro.get('countiesM').map(county => ({
                      label: county,
                      value: county
                    }))
                    .toJS()
                  }
                  label="County" />
              </Col>
              <Col sm={4}>
                <Input
                  type="select"
                  multi
                  valueLink={linkProperty('state')}
                  options={
                    metro.get('statesM').map(state => ({
                      label: state,
                      value: state
                    }))
                    .toJS()
                  }
                  label="State" />
              </Col>
            </Row>
          }

          {!isMap &&
            <Input
              type="select"
              multi
              valueLink={linkProperty('city')}
              options={
                metro.get('citiesM').sort().map(city => ({
                  label: city,
                  value: city
                }))
                .toJS()
              }
              label="City" />
          }

          {this.renderField('property', 'strNo', true)}
          {this.renderField('property', 'strName', true)}
        </Col>

        <Col xs={colSize}>
          {this.renderField('property', 'pid')}
          {this.renderField('property', 'acresCt')}
          {this.renderField('property', 'floodZoneTM', true)}
        </Col>
      </Row>
    )
  }

  renderSaleFields () {
    const { colSize = 6, account } = this.props
    const isAg = account.getIn(['group', 'isAg'])

    return (
      <Row>
        {this.renderTransactionTitle('Sale')}

        <Col xs={colSize}>
          {this.renderField('sale', 'saleT')}
          {this.renderField('sale', 'docNo')}
          {this.renderField('sale', 'closeDt')}
          {this.renderField('sale', 'perSfPx')}
          {this.renderField('sale', 'salePx')}
          {this.renderField('sale', 'acquisTM', true)}
          {this.renderField('sale', 'capRtPct')}
          {this.renderField('sale', 'leaseFeeT', true)}
          {isAg && this.renderField('sale', 'commodityTM', true)}
          {this.renderField('sale', 'createdAt', true)}
        </Col>

        <Col sm={colSize}>
          {this.renderUseTMField('sale')}
          {this.renderField('sale', 'propUse', true)}
          {this.renderField('sale', 'propName', true)}
          {this.renderField('sale', 'unitPx')}
          {this.renderField('sale', 'saleGbaSf')}
          {this.renderField('sale', 'saleLandSf')}
          {this.renderField('sale', 'onMktDay', true)}
        </Col>

        <Col xs={12}>
          <Row>
            <Col sm={6}>
              {this.renderField('sale', 'buyer', true)}
              {this.renderField('sale', 'trueByr', true)}
            </Col>

            <Col sm={6}>
              {this.renderField('sale', 'seller', true)}
              {this.renderField('sale', 'trueSlr', true)}
            </Col>
          </Row>

          {this.renderField('sale', 'remarks')}
        </Col>
      </Row>
    )
  }

  renderSaleSfrFields () {
    const { colSize = 6 } = this.props

    return (
      <Row>
        {this.renderTransactionTitle('Sale')}

        <Col sm={colSize}>
          {this.renderField('sale', 'saleT')}
          {this.renderUseTMField('sale')}
          {this.renderField('sale', 'propUse')}
          {this.renderField('sale', 'salePx')}
          {this.renderField('sale', 'deedT')}
          {this.renderField('sale', 'acquisTM')}
          {this.renderField('sale', 'perSfPx', true)}
          {this.renderField('sale', 'saleGbaSf', true)}
          {this.renderField('sale', 'saleLandSf', true)}
          {this.renderField('sale', 'createdAt', true)}
        </Col>

        <Col sm={colSize}>
          {this.renderField('sale', 'docNo')}
          {this.renderField('sale', 'closeDt')}
          {this.renderField('sale', 'buyer')}
          {this.renderField('sale', 'buyerAgt', true)}
          {this.renderField('sale', 'seller')}
          {this.renderField('sale', 'sellerAgt', true)}
          {this.renderField('sale', 'leaseFeeT', true)}
        </Col>

        <Col sm={12}>
          {this.renderField('sale', 'rediRemarks', true)}
          {this.renderField('sale', 'remarks', true)}
        </Col>
      </Row>
    )
  }

  renderSaleAgFields () {
    const { colSize = 6 } = this.props

    return (
      <Row>
        {this.renderTransactionTitle('Sale')}

        <Col sm={colSize}>
          {this.renderField('sale', 'saleT')}
          {this.renderUseTMField('sale')}
          {this.renderField('sale', 'propUse')}
          {this.renderField('sale', 'commodityTM', true)}
          {this.renderField('sale', 'salePx')}
          {this.renderField('sale', 'perAcrePx')}
          {this.renderField('sale', 'capRtPct', true)}
          {this.renderField('sale', 'closeDt')}
          {this.renderField('sale', 'acquisTM')}
          {this.renderField('sale', 'createdAt', true)}
        </Col>

        <Col sm={colSize}>
          {this.renderField('sale', 'docNo')}
          {this.renderField('sale', 'buyer')}
          {this.renderField('sale', 'buyerAgt', true)}
          {this.renderField('sale', 'seller')}
          {this.renderField('sale', 'sellerAgt', true)}
        </Col>

        <Col sm={12}>
          {this.renderField('sale', 'remarks')}
          {this.renderField('sale', 'rediRemarks', true)}
        </Col>
      </Row>
    )
  }

  renderLeaseFields () {
    const { colSize = 6 } = this.props
    const { transaction } = this.state
    const isLeaseAvailable = transaction.get('leaseT') === 'Available'

    return (
      <Row>
        {this.renderTransactionTitle('Lease')}

        <Col sm={colSize}>
          {this.renderField('lease', 'leaseT')}
          {this.renderField('lease', 'leaseStDt')}
          <Row>
            <Col sm={colSize}>
              {this.renderField('lease', 'askRentLPx')}
            </Col>
            <Col sm={colSize}>
              {this.renderField('lease', 'askRentHPx')}
            </Col>
          </Row>
          {!isLeaseAvailable && this.renderField('lease', 'leasePx', true)}
          {!isLeaseAvailable && this.renderField('lease', 'rentSfPx')}
          {!isLeaseAvailable && this.renderField('lease', 'yrRentPx', true)}
          {!isLeaseAvailable && this.renderField('lease', 'yrRentSfPx', true)}
          {this.renderField('lease', 'leaseTermT', true)}
          {this.renderField('lease', 'leaseOptT', true)}
          {this.renderField('lease', 'isFullFlr', true)}
          {this.renderField('lease', 'isPurOpt', true)}
          {this.renderField('lease', 'isSubLease', true)}
          {this.renderField('lease', 'createdAt', true)}
        </Col>

        <Col sm={colSize}>
          {this.renderUseTMField('lease')}
          {this.renderField('lease', 'propUse', true)}
          {this.renderField('lease', 'propName', true)}
          {this.renderField('lease', 'lessee')}
          {this.renderField('lease', 'lesseeDba', true)}
          {this.renderField('lease', 'lessor')}
          {this.renderField('lease', 'lessorDba', true)}
          {this.renderField('lease', 'rentableSf')}
          {this.renderField('lease', 'floorLvl', true)}
          <Row>
            <Col sm={colSize}>
              {this.renderField('lease', 'rentableLSf')}
            </Col>
            <Col sm={colSize}>
              {this.renderField('lease', 'rentableHSf')}
            </Col>
          </Row>
        </Col>

        <Col sm={12}>
          {this.renderField('lease', 'remarks')}
        </Col>
      </Row>
    )
  }

  renderIncExpFields () {
    const { colSize = 6 } = this.props

    return (
      <Row>
        {this.renderTransactionTitle('Income & expenses')}

        <Col sm={colSize}>
          {this.renderField('incexp', 'incStYr')}
          {this.renderField('incexp', 'incEndYr', true)}
          {this.renderField('incexp', 'grossIncPx')}
          {this.renderField('incexp', 'expPx', true)}
          {this.renderField('incexp', 'createdAt', true)}
        </Col>

        <Col sm={colSize}>
          {this.renderUseTMField('incexp')}
          {this.renderField('incexp', 'propUse', true)}
          {this.renderField('incexp', 'propName', true)}
          {this.renderField('incexp', 'netIncPx', true)}
          {this.renderField('incexp', 'capRtPct')}
          {this.renderField('incexp', 'netRntSf')}
        </Col>

        <Col sm={12}>
          {this.renderField('incexp', 'remarks')}
        </Col>
      </Row>
    )
  }

  renderIncExpAgFields () {
    const { colSize = 6 } = this.props

    return (
      <Row>
        {this.renderTransactionTitle('Income & expenses')}

        <Col sm={colSize}>
          {this.renderUseTMField('incexp')}
          {this.renderField('incexp', 'propUse')}
          {this.renderField('incexp', 'incStYr')}
          {this.renderField('incexp', 'incEndYr')}
          {this.renderField('incexp', 'createdAt', true)}
        </Col>

        <Col sm={colSize}>
          {this.renderField('incexp', 'netIncPx')}
          {this.renderField('incexp', 'oprExpRtPct')}
          {this.renderField('incexp', 'commodityTM')}
        </Col>
      </Row>
    )
  }

  renderConstFields () {
    const { colSize = 6 } = this.props

    return (
      <Row>
        {this.renderTransactionTitle('Construction costs')}

        <Col sm={colSize}>
          {this.renderField('const', 'constT')}
          {this.renderField('const', 'constPx', true)}
          {this.renderField('const', 'demlPx', true)}
          {this.renderField('const', 'adjGbaSf', true)}
          {this.renderField('const', 'perSfPx')}
          {this.renderField('const', 'createdAt', true)}
        </Col>

        <Col sm={colSize}>
          {this.renderUseTMField('const')}
          {this.renderField('const', 'propUse', true)}
          {this.renderField('const', 'propName', true)}
          {this.renderField('const', 'contractor', true)}
        </Col>

        <Col sm={12}>
          {this.renderField('const', 'remarks')}
        </Col>
      </Row>
    )
  }

  renderExhibitFields () {
    const { metadata } = this.props
    const { linkExhibit } = this.state
    const exhibits = metadata.get('exhibit').get('_types').toJS() || []

    return (
      <Row>
        <Col sm={12}>
          <Input
            type="select"
            multi
            valueLink={linkExhibit('exhibitType')}
            options={
              exhibits.map(exh => ({
                label: exh,
                value: exh
              }))
            }
            label="Contains exhibit" />
          <Input
            type="text"
            valueLink={linkExhibit('exhibitDesc')}
            label="Contains exhibit description" />
        </Col>
      </Row>
    )
  }

  renderInspectionFields () {
    const { account } = this.props
    const isAdmin = account.get('isAdmin')
    if (!isAdmin) return null

    return (
      <Row>
        <Col sm={12}>
          {this.renderField('inspection', 'verifStatT')}
        </Col>
      </Row>
    )
  }

  renderSavedSearch () {
    const { savedSearches, savedSearch } = this.state

    return (
      <div className="redi-component-saved-search">
        <Input
          type="select"
          options={savedSearches.map(s => ({
            value: s.get('id'),
            label: s.get('desc')
          })).toJS()}
          onChange={::this.handleSaveSelect}
          placeholder="Select saved search..."
          name="seaches"
          value={null} />

        {savedSearch &&
          <p>
            <strong>{savedSearch.get('desc')}</strong> has been loaded.
            {' '}
            (<a href="#" onClick={::this.handleSaveRemove}>Delete</a>)
            {savedSearch.get('notify') &&
            <span>
              {' '}
              (<a href="#" onClick={::this.handleSaveUnsubscribe}>Stop notifications</a>)
            </span>
            }
          </p>
        }
      </div>
    )
  }

  handleSaveSelect (saveId) {
    if (!saveId) return

    const { savedSearches } = this.state

    const savedSearch = savedSearches.find(s => s.get('id') === saveId)
    if (!savedSearch) return

    if (this.props.onSavedSearch) this.props.onSavedSearch(savedSearch)

    const criteria = savedSearch.get('criteria')
    const genUseTM = this.getGenUseTMList()

    this.setState({
      savedSearch: savedSearch,
      property: criteria.get('property') || Map({ genUseTM }),
      transaction: criteria.get('transaction') || Map({ type: 'Sale', isPrivate: false }),
      exhibit: criteria.get('exhibit') || Map(),
      inspection: criteria.get('inspection') || Map()
    })
  }

  async handleSaveRemove (evt) {
    if (evt) evt.preventDefault()

    const { savedSearch, savedSearches } = this.state
    const { store, notify } = this.context

    try {
      await store.delete(`/searches/${savedSearch.get('id')}`)

      const idx = savedSearches.findIndex(s => s.get('id') === savedSearch.get('id'))
      this.setState({
        savedSearches: savedSearches.delete(idx),
        savedSearch: null
      })
      notify('Save search removed.')
    }
    catch (er) {
      console.error(er)
      notify(er.response.body.error)
    }
  }

  async handleSaveUnsubscribe (evt) {
    if (evt) evt.preventDefault()

    let { savedSearch, savedSearches } = this.state
    const { store, notify } = this.context

    try {
      await store.post(`/searches/${savedSearch.get('id')}`, {
        notify: false
      })
      const idx = savedSearches.findIndex(d => d.get('id') === savedSearch.get('id'))
      this.setState({
        savedSearch: savedSearch.set('notify', false),
        savedSearches: savedSearches.update(idx, item => item.set('notify', false))
      })
      notify('Successfully unsubscribed from search.')
    }
    catch (er) {
      console.log(er)
      notify(er.response.body.error)
    }
  }

  renderIsPrivateField () {
    const { linkTransaction } = this.state
    return (
      <Input type="switch" checkedLink={linkTransaction('isPrivate')} label="Search through 'My Records' only" />
    )
  }

  removeInvalidDates (transaction, fieldsToCheck) {
    return transaction.withMutations(trans => {
      for (const field of fieldsToCheck) {
        if (trans.get(field) === 'Invalid date') {
          trans.delete(field)
        }
      }
    })
  }

  handleSubmit (evt) {
    evt.preventDefault()

    const { onSubmit, geometry } = this.props
    const { property, transaction, inspection, exhibit } = this.state
    const { store } = this.context

    // check invalid dates
    const fields = ['closeDt_start', 'closeDt_end', 'leaseStDt_start', 'leaseStDt_end', 'leaseEndDt_start', 'leaseEndDt_end']
    const cTransaction = this.removeInvalidDates(transaction, fields)

    // store last search
    store.storage.lastSearch = JSON.stringify({
      property: property.toJS(),
      transaction: cTransaction.toJS(),
      exhibit: exhibit.toJS(),
      inspection: inspection.toJS(),
      geometry
    })

    let search = cTransaction
      .merge(property)
      .merge(inspection)
      .merge(exhibit)

    if (geometry) {
      search = search.merge({ geometry: JSON.stringify(geometry) })
    }

    this.setState({
      searchBtnTxt: 'Searching...',
      disableSearchBtn: true
    })

    onSubmit(search)
  }

  handleClear () {
    document.location.href = document.location.pathname
  }

  render() {
    const { transaction, searchBtnTxt, disableSearchBtn } = this.state
    const { account, colSize = 6 } = this.props
    const type = transaction.get('type')
    const isAgRes = account.get('isAgRes')
    const isSfr = account.getIn(['group', 'isSfr'])
    const isAg = account.getIn(['group', 'isAg'])

    return (
      <div>
        {this.renderGeometryInstructions()}

        <Row>
          <Col xs={colSize}>
            {this.renderIsPrivateField()}
          </Col>
          <Col xs={colSize}>
            {this.renderSavedSearch()}
          </Col>
        </Row>

        <hr className="redi-component-hr" />
        <Nav
          bsStyle="pills"
          activeKey={transaction.get('type')}
          onSelect={::this.handleTransactionSwitch}>
          <NavItem eventKey="Sale">Sales</NavItem>
          {!isAgRes && <NavItem eventKey="Lease">Leases</NavItem>}
          {!isSfr && <NavItem eventKey="IncExp">Income &amp; expenses</NavItem>}
          {!isAgRes && <NavItem eventKey="Const">Const. costs</NavItem>}
        </Nav>
        <hr className="redi-component-hr" />

        {!isAgRes && this.renderPropertyFields()}
        {isAg && this.renderPropertyAgFields()}
        {isSfr && this.renderPropertySfrFields()}

        <hr className="redi-component-hr" />

        {!isAgRes && this[`render${type}Fields`]()}
        {isAg && this[`render${type}AgFields`]()}
        {isSfr && this.renderSaleSfrFields()}

        {this.renderExhibitFields()}
        {type === 'Sale' && this.renderInspectionFields()}
        <ButtonToolbar>
          <Button
            type="submit"
            bsStyle="primary"
            disabled={disableSearchBtn}
            onClick={::this.handleSubmit}>
            {searchBtnTxt}
          </Button>
          <Button bsStyle="warning" onClick={::this.handleClear}>Start over</Button>
        </ButtonToolbar>
      </div>
    )
  }
}

export default SearchFields



// WEBPACK FOOTER //
// ./modules/shared/pages/search/fields.js